/**
 * Privacy-conscious analytics hooks.
 * Emits events that can be wired to an analytics backend.
 * No personal data is collected by default.
 */

export type AnalyticsEvent =
  | { name: 'tool_page_visit'; tool: string }
  | { name: 'game_start'; tool: string }
  | { name: 'round_complete'; tool: string; result: string }
  | { name: 'room_create'; tool: string }
  | { name: 'room_join'; tool: string }
  | { name: 'template_use'; template: string }
  | { name: 'share'; tool: string }
  | { name: 'error'; message: string };

function consentAllowsAnalytics(): boolean {
  try {
    return localStorage.getItem('chance-consent') === 'all';
  } catch {
    return false;
  }
}

export function track(event: AnalyticsEvent) {
  // Only send analytics if the user has consented to non-essential cookies.
  if (!consentAllowsAnalytics()) return;

  // Placeholder: replace with actual analytics implementation.
  if (typeof window !== 'undefined' && 'gtag' in window) {
    try {
      (window as any).gtag('event', event.name, event);
    } catch {}
  }

  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.log('[Analytics]', event);
  }
}

export function initPageTracking() {
  const gameContainer = document.querySelector('[data-game]');
  if (gameContainer) {
    track({ name: 'tool_page_visit', tool: gameContainer.getAttribute('data-game') || 'unknown' });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPageTracking);
} else {
  initPageTracking();
}
